import { render, staticRenderFns } from "./changRefund.vue?vue&type=template&id=4621f845&scoped=true&"
import script from "./changRefund.vue?vue&type=script&lang=js&"
export * from "./changRefund.vue?vue&type=script&lang=js&"
import style0 from "./changRefund.vue?vue&type=style&index=0&id=4621f845&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4621f845",
  null
  
)

export default component.exports